//React imports
import React, { useEffect } from "react";

import FooterComponent from "../../components/home/FooterComponent.js";

//Imports assets such as images
import NavBarComponent from "../../components/navBar/NavBarComponent.js";
import MembershipsComponent from "../../components/product/memberships/membershipsComponent";

export default function MembershipsProductPage() {
    return (
        <div>
            <div className="updated-page-wrapper">
                <NavBarComponent shouldShowPremiumBanner={true} />
                <MembershipsComponent />
                <FooterComponent />
            </div>
        </div>
    );
}

